import React, { FunctionComponent } from 'react';

import styles from './index.module.scss';

type Props = {
  id;
  color;
  title;
  currentIndex;
  onClick;
};

const ColorSpot: FunctionComponent<Props> = ({
  id,
  color,
  title,
  currentIndex,
  onClick,
}): JSX.Element => {
  const active = id === currentIndex ? styles['active'] : '';

  return (
    <button
      style={{ backgroundColor: color }}
      className={`${styles.root} ${active}`}
      onClick={() => onClick(id)}>
      <p>{title}</p>
    </button>
  );
};

export default ColorSpot;
